import { chrome, firefox } from './browser';
import { css } from 'styled-components';

const outlineColor = '#5098FF';
const outlineWidth = 3;

const outline = (radius = 0) => {
    if (radius > 0) {
        return css`
            box-shadow: 0 0 5px ${outlineWidth}px ${outlineColor};
            border-radius: ${radius}px;

            ${firefox} {
                box-shadow: inherit;
                outline: ${outlineColor} solid ${outlineWidth}px;
                outline-color: -moz-mac-focusring;
                -moz-outline-radius: ${radius + outlineWidth}px;
            }
        `;
    } else {
        return css`
            outline: ${outlineColor} solid ${outlineWidth}px;

            ${firefox} {
                outline-color: -moz-mac-focusring;
                -moz-outline-radius: 2px;
            }
            ${chrome} {
                outline-color: -webkit-focus-ring-color;
                outline-style: auto;
                outline-width: 5px;
            }
        `;
    }
};

export default outline;
